import React, { useEffect, useState } from "react";
import {
    Route,
    Switch,
    Link,
    useRouteMatch,
    useHistory,
} from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import SearchBar from "material-ui-search-bar";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from '@material-ui/icons/Edit';
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
import {
    InputLabel,
    Dialog,
    TextField,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    MenuItem,
    Select,
    FormControlLabel,
    Grid,
    CircularProgress,
    Tooltip,
    Typography
} from "@material-ui/core";
// Amplify components
import { Auth } from "aws-amplify";

// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationContext from "views/Components/Context.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import Heading from "components/Heading/Heading";
import { CloudUpload } from "@material-ui/icons";

import { DropzoneArea } from 'material-ui-dropzone';
import MDEditor from '@uiw/react-md-editor';
import MarkdownEditorWithPreview from "components/MarkdownEditor/MarkdownEditorWithPreview";


const useStyles = makeStyles(styles);
// const usemodalStyles = makeStyles(modalStyle);
const useextendedFormsStyles = makeStyles(extendedFormsStyle);
const usesweetAlertStyle = makeStyles(sweetAlertStyle);
const usedashboardStyle = makeStyles(dashboardStyle);


export default function CourseProjects() {
    const dashboardClasses = usedashboardStyle();
    const PERMISSION = ["read", "clone", "write", "audit", "own"];
    const [json, setjson] = React.useState(
        JSON.stringify({
            stages: [
                [
                    {
                        status: "active",
                        name: "Scikit_Learn_Audit_Demo",
                        entities: [
                            {
                                description: "",
                                type: {
                                    username: "ubuntu",
                                    src: "AWS",
                                    gpu_enabled: false,
                                    name: "Environment",
                                    kernel: {
                                        python: true,
                                        r: false,
                                        matlab: false,
                                    },
                                    single_project: true,
                                    os: "Ubuntu",
                                    region: "us-west-2",
                                    start_from: "DOCKERHUB",
                                    ami_id: "",
                                    docker_hub_url: "jdadaptivealgo/env_1_report",
                                    service_type: "jns",
                                    use_ac: false,
                                    config: {
                                        callback: "",
                                        post_execution: "",
                                        pre_execution: "",
                                        parameters: [
                                            {
                                                encoded: true,
                                                EXPERIMENT_ID:
                                                    "EXPERIMENT#e7efea679b4b4a058e4cc5b4b57aef7a",
                                            },
                                            {
                                                encoded: false,
                                                TYPE: "Model",
                                            },
                                        ],
                                        run_command: "",
                                    },
                                    duration: 1,
                                    size: "t2.medium",
                                },
                                name: "Environment",
                            },
                            {
                                status: "active",
                                description: "",
                                access_role: "public",
                                type: {
                                    src:
                                        "https://github.com/rh-2019/Scikit_Learn_QuSandbox_Demo.git",
                                    name: "Model",
                                    github_branch: "",
                                    src_type: "Github",
                                    config: {
                                        callback: "",
                                        post_execution: "",
                                        pre_execution: "",
                                        parameters: [],
                                        run_command: "",
                                    },
                                },
                                name: "Audit",
                            },
                        ],
                        description: "",
                    },
                ],
            ],
            description: "",
            connections: [],
            name: "Scikit_Learn_Audit",
        })
    );

    const classes = useStyles();
    const history = useHistory();
    const sweetAlertClasses = usesweetAlertStyle();
    const extendedFormsClasses = useextendedFormsStyles();
    const images = require.context("assets/img", true);
    const imagesArray = [
        images("./1.jpg"),
    ];
    const [user, setUser] = React.useState();
    const [isEditMode, setIsEditMode] = React.useState(false);
    const [allProjects, setAllProjects] = React.useState([]);
    const [currentProject, setCurrentProject] = React.useState(null);

    const [permanentProjects, setPermanentProjects] = React.useState([]);
    const [userType, setUserType] = React.useState("");
    const [modal, setModal] = React.useState(false);
    const [head, sethead] = React.useState("");
    const [iframeLink, setiframeLink] = React.useState("");
    const [streamlitLink, setstreamlitLink] = React.useState("");
    const [gistLink, setGistLink] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [colab, setcolab] = React.useState("");
    const [tag, settag] = React.useState("default");
    const [name, setName] = React.useState("");
    const [version, setVersion] = React.useState("2.0");
    const [brief, setBrief] = React.useState("");
    const [iconImage, setIconImage] = useState(null);
    const [alert, setAlert] = React.useState(null);
    const { path, url } = useRouteMatch();
    const [searchValue, setSearchValue] = React.useState("");
    const { showNotification } = React.useContext(NotificationContext);
    const [loading, setLoading] = React.useState(true);

    const [createProjectState, setCreateProjectState] = React.useState(0);

    // template
    const [templateFetched, setTemplateFetched] = React.useState(false);
    const [templates, setTemplates] = React.useState([]);
    const [projectTemplate, setProjectTemplate] = React.useState({});
    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(function (user) {
                setUser(user);
                setUserType(
                    user.signInUserSession.accessToken.payload["cognito:groups"][0]
                );
            })
            .then(() => { })
            .catch((err) => {

                if (err === "not authenticated") {
                    history.push("/auth/login-page");
                }
            });
        // setAllApis(listOfApis);
    }, []);

    useEffect(() => {
        setLoading(true);
        if (user) {
            let token = user.signInUserSession.accessToken.jwtToken;
            fetch(process.env.REACT_APP_BACK_END_URL + "/project", {
                method: "GET",
                mode: "cors",
                credentials: "omit",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }).then(
                function (res) {
                    res.json().then(function (data) {
                        const filteredProjects = data.Items.filter(
                            (project) => project.projectVersion === "2.0"
                        );
                        setAllProjects(filteredProjects);
                        setPermanentProjects(filteredProjects);
                        setLoading(false);
                    });
                },
                function (err) {
                    console.log(err);
                    setLoading(false); // Ensures loading is stopped even in case of error
                }
            );
        }
    }, [user]);


    const deleteAlert = (projectData) => {

        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => handleDeleteProject(projectData)}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.success
                }
                cancelBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.danger
                }
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
            >
                You will not be able to recover this Project!
            </SweetAlert>
        );
    };

    const cloneAlert = (projectData) => {

        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => handleCloneProject(projectData)}
                onCancel={() => hideAlert()}
                confirmBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.success
                }
                cancelBtnCssClass={
                    sweetAlertClasses.button + " " + sweetAlertClasses.danger
                }
                confirmBtnText="Yes, clone it!"
                cancelBtnText="Cancel"
                showCancel
            >
                You will create a new Project with _copy as suffix!
            </SweetAlert>
        );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const handleDeleteProject = (projectData) => {
        let token = user.signInUserSession.accessToken.jwtToken;
        fetch(
            process.env.REACT_APP_BACK_END_URL +
            "/project/" +
            projectData.PK.split("#")[1],
            {
                method: "DELETE",
                mode: "cors",
                credentials: "omit",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        )
            .then(function (res) {
                return res.json();
            })
            .then(function () {
                let data = allProjects.filter(
                    (project) => project.PK !== projectData.PK
                );
                let permanentData = permanentProjects.filter(
                    (project) => project.PK !== projectData.PK
                );
                setAllProjects(data);
                setPermanentProjects(permanentData);
                showNotification("Project deleted successfully.", "quSandBoxColor");
            })
            .catch((error) => {
                showNotification("Delete Failed.", "danger");
                console.log(error);
            });
        hideAlert();
    };

    const handleCloneProject = (projectData) => {
        let token = user.signInUserSession.accessToken.jwtToken;
        fetch(
            process.env.REACT_APP_BACK_END_URL +
            "/project?id=" +
            projectData.PK.split("#")[1],
            {
                method: "POST",
                mode: "cors",
                credentials: "omit",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.hasOwnProperty("Items")) {
                    setAllProjects((prevState) => [...prevState, data.Items[0]]);
                    setPermanentProjects((prevState) => [...prevState, data.Items[0]]);
                    showNotification("Project cloned successfully.", "quSandBoxColor");
                } else {
                    showNotification("Clone Failed.", "danger");
                }
                return data;
            })
            .catch((error) => {
                showNotification("Clone Failed.", "danger");
                console.log(error);
            });
        hideAlert();
    };

    const createProject = () => {
        setCurrentDialog("Create");
        setModal(true);
    };
    const handleClose = () => {
        setCreateProjectState(0);
        setModal(false);
        clearCreateModel();
    };

    const clearCreateModel = () => {
        setBrief("");
        setVersion("2.0");
        setName("");
        setGistLink("");
        setDescription("");
        if (templateFetched) {
            clearProjectTemplate();
        } else {
            setProjectTemplate({});
        }
        setjson(
            JSON.stringify({
                stages: [
                    [
                        {
                            status: "active",
                            name: "Scikit_Learn_Audit_Demo",
                            entities: [
                                {
                                    description: "",
                                    type: {
                                        username: "ubuntu",
                                        src: "AWS",
                                        gpu_enabled: false,
                                        name: "Environment",
                                        kernel: {
                                            python: true,
                                            r: false,
                                            matlab: false,
                                        },
                                        single_project: true,
                                        os: "Ubuntu",
                                        region: "us-west-2",
                                        start_from: "DOCKERHUB",
                                        ami_id: "",
                                        docker_hub_url: "jdadaptivealgo/env_1_report",
                                        service_type: "jns",
                                        use_ac: false,
                                        config: {
                                            callback: "",
                                            post_execution: "",
                                            pre_execution: "",
                                            parameters: [
                                                {
                                                    encoded: true,
                                                    EXPERIMENT_ID:
                                                        "EXPERIMENT#e7efea679b4b4a058e4cc5b4b57aef7a",
                                                },
                                                {
                                                    encoded: false,
                                                    TYPE: "Model",
                                                },
                                            ],
                                            run_command: "",
                                        },
                                        duration: 1,
                                        size: "t2.medium",
                                    },
                                    name: "Environment",
                                },
                                {
                                    status: "active",
                                    description: "",
                                    access_role: "public",
                                    type: {
                                        src:
                                            "https://github.com/rh-2019/Scikit_Learn_QuSandbox_Demo.git",
                                        name: "Model",
                                        github_branch: "",
                                        src_type: "Github",
                                        config: {
                                            callback: "",
                                            post_execution: "",
                                            pre_execution: "",
                                            parameters: [],
                                            run_command: "",
                                        },
                                    },
                                    name: "Audit",
                                },
                            ],
                            description: "",
                        },
                    ],
                ],
                description: "",
                connections: [],
                name: "Scikit_Learn_Audit",
            })
        );
    };

    const clearProjectTemplate = () => {
        setProjectTemplate({
            summary: templates[0].SK,
            audit: templates[0].SK,
            dataExplore: templates[0].SK,
            pipeline: templates[0].SK,
            data: templates[0].SK,
            model: templates[0].SK,
            environment: templates[0].SK,
            explainability: templates[0].SK,
            fairness: templates[0].SK,
            monitoring: templates[0].SK,
            findings: templates[0].SK,
            recommendations: templates[0].SK,
        });
    };
    useEffect(() => {
        if (templateFetched) {
            clearProjectTemplate();
        }
    }, [templates, templateFetched]);


    const handleCreateProject = () => {
        handleClose();
        let token = user.signInUserSession.accessToken.jwtToken;
        fetch(process.env.REACT_APP_BACK_END_URL + "/project", {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
            body: JSON.stringify({
                projectBrief: brief,
                projectVersion: version,
                projectName: name,
                projectGistLink: gistLink.split("gist.github.com/")[1],
                projectDescription: description,
                json: json,
                projectTemplate: JSON.stringify(projectTemplate),
            }),
        })
            .then((res) => res.json())
            .then((data) => {

                if (data.hasOwnProperty("Items")) {
                    setAllProjects((prevState) => [...prevState, data.Items[0]]);
                    setPermanentProjects((prevState) => [...prevState, data.Items[0]]);
                    showNotification(
                        "New course created successfully.",
                        "quSandBoxColor"
                    );
                } else {
                    showNotification("Course creation failed.", "danger");
                }
                setCreateProjectState(0);
                clearCreateModel();
                return data;
            })
            .catch((error) => {
                showNotification("Course creation failed.", "danger");
                console.log(error);
            });
    };


    const handleIconUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setIconImage(file);
        }
    };

    const searchInputValue = (e) => {
        setSearchValue(e);
        if (e == "") {
            setAllProjects(permanentProjects);
            return;
        }
        var newList = permanentProjects.filter(
            (project) =>
                project.projectName.toLowerCase().includes(e.toLowerCase()) ||
                (project.projectBrief &&
                    project.projectBrief.toLowerCase().includes(e.toLowerCase()))
        );
        setAllProjects(newList);
    };

    const randomImage = imagesArray[Math.floor(Math.random() * imagesArray.length)];

    const dialogStages = ["Create", "Upload", "Select Template", "Update Outline", "Submit"];
    const [courseOutline, setCourseOutline] = React.useState("# Module 0: **On Machine Learning Applications in Investments**\n**Description**: This module provides an overview of the use of machine learning (ML) in investment practices, including its potential benefits and common challenges. It highlights examples where ML techniques have outperformed traditional investment models.\n\n**Learning Outcomes**:\n- Understand the motivations behind using ML in investment strategies.\n- Recognize the challenges and solutions in applying ML to finance.\n- Explore practical applications of ML for predicting equity returns and corporate performance.\n### Module 1: **Alternative Data and AI in Investment Research**\n**Description**: This module explores how alternative data sources combined with AI are transforming investment research by providing unique insights and augmenting traditional methods.\n\n**Learning Outcomes**:\n- Identify key sources of alternative data and their relevance in investment research.\n- Understand how AI can process and derive actionable insights from alternative data.\n- Analyze real-world use cases showcasing the impact of AI in research and decision-making.\n### Module 2: **Data Science for Active and Long-Term Fundamental Investing**\n**Description**: This module covers the integration of data science into long-term fundamental investing, discussing how quantitative analysis can enhance traditional methods.\n\n**Learning Outcomes**:\n- Learn the foundational role of data science in long-term investment strategies.\n- Understand the benefits of combining data science with active investing.\n- Evaluate case studies on the effective use of data science to support investment decisions.\n### Module 3: **Unlocking Insights and Opportunities**\n**Description**: This module focuses on techniques and strategies for using data-driven insights to identify market opportunities and enhance investment management processes.\n\n**Learning Outcomes**:\n- Grasp the importance of leveraging advanced data analytics for opportunity identification.\n- Understand how to apply insights derived from data to optimize investment outcomes.\n- Explore tools and methodologies that facilitate the unlocking of valuable investment insights.\n### Module 4: **Advances in Natural Language Understanding for Investment Management**\n**Description**: This module highlights the progression of natural language understanding (NLU) and its application in finance. It covers recent developments and their implications for asset management.\n\n**Learning Outcomes**:\n- Recognize advancements in NLU and their integration into investment strategies.\n- Explore trends and applications of NLU in financial data analysis.\n- Understand the technical challenges and solutions associated with implementing NLU tools.\n### Module 5: **Extracting Text-Based ESG Insights - A Hands-on Guide**\n**Description**: This module provides a practical guide on using text-based data to gather environmental, social, and governance (ESG) insights, showcasing how NLP can enhance ESG analysis.\n\n**Learning Outcomes**:\n- Learn how to use NLP tools to extract and analyze text-based ESG data.\n- Understand the role of ESG analysis in modern investment decision-making.\n- Apply hands-on techniques for interpreting and utilizing ESG-related data in portfolio management.\n### Module 6: **Machine Learning and Big Data Trade Execution Support**\n**Description**: This module explores how machine learning and big data are applied to enhance trade execution processes, focusing on increasing efficiency and accuracy.\n\n**Learning Outcomes**:\n- Understand the integration of ML and big data in supporting trade execution.\n- Identify various stages of the trading process where ML can be applied.\n- Analyze use cases of ML-enhanced trade execution and their impact on financial outcomes.\n### Module 7: **Machine Learning for Microstructure Data-Driven Execution Algorithms**\n**Description**: This module delves into the use of machine learning for interpreting microstructure data to develop advanced execution algorithms that optimize trading strategies.\n\n**Learning Outcomes**:\n- Learn the importance of microstructure data in developing trading algorithms.\n- Understand how ML techniques can predict trade volumes, spreads, and volatility.\n- Evaluate case studies on successful application of ML-driven microstructure analysis.\n### Module 8: **Intelligent Customer Service in Finance**\n**Description**: This module discusses the deployment of AI-driven customer service solutions in finance, illustrating how technology is transforming client interactions and service efficiency.\n\n**Learning Outcomes**:\n- Understand the application of AI in customer service for financial institutions.\n- Explore the use of voice, NLP, and knowledge graphs in enhancing client services.\n- Evaluate case studies on the benefits and challenges of AI-powered customer service solutions.\n### Module 9: **Accelerated AI and Use Cases in Investment Management**\n**Description**: This module examines the significance of accelerated computing in AI and its implications for investment management, including relevant case studies.\n\n**Learning Outcomes**:\n- Learn how advancements in computing power contribute to the effectiveness of AI.\n- Understand the role of accelerated AI in improving financial data processing and decision-making.\n- Analyze specific use cases where accelerated AI has enhanced investment strategies.\n### Module 10: **Symbolic AI - A Case Study**\n**Description**: This module presents a case study on symbolic AI and its applications in investment management, demonstrating its unique contributions to strategic financial operations.\n\n**Learning Outcomes**:\n- Define symbolic AI and differentiate it from other AI techniques.\n- Understand how symbolic AI can be applied to portfolio management.\n- Explore a practical case study detailing the impact and results of symbolic AI in finance. \n");
    const [uploadedFiles, setUploadedFiles] = React.useState([]);
    const [startFiles, setStartFiles] = React.useState([]);
    const [template, setTemplate] = React.useState("Create a course containing 8 modules. Each module should have a brief description and a list of learning objectives.");
    const [currentDialog, setCurrentDialog] = React.useState("Create");

    const handleFileUpload = (files) => {
        setUploadedFiles(files);
    };
    const handleCourseOutlineChange = (value) => {
        setCourseOutline(value);
    };
    const handleNext = () => {
        if (currentDialog === "Create Course") {
            setCurrentDialog("Upload");
        } else if (currentDialog === "Upload") {
            setCurrentDialog("Update Outline");
        } else if (currentDialog === "Update Outline") {
            setCurrentDialog("Submit");
        }
    };

    const renderDialogContent = () => {
        switch (currentDialog) {
            case "Create":
                return (
                    <div>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Course Name"
                            type="text"
                            fullWidth
                            required
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                        />
                        <TextField
                            margin="dense"
                            id="brief"
                            label="Brief Description"
                            type="text"
                            fullWidth
                            multiline
                            rows={3}
                            value={brief}
                            onChange={(event) => setBrief(event.target.value)}
                        />
                        {/* Icon Image Upload */}
                        <Button
                            variant="contained"
                            component="label"
                            color="info"
                            style={{ marginTop: '20px' }}
                        >
                            <CloudUpload /> &nbsp; Upload Image
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleIconUpload}
                            />
                        </Button>
                        {iconImage && (
                            <div style={{ marginTop: '10px' }}>
                                <strong>Selected Image:</strong> {iconImage.name}
                            </div>
                        )}
                    </div>
                );
            case "Upload":
                return (
                    <DropzoneArea
                        onChange={handleFileUpload}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        dropzoneText="Drag and drop or click here to upload files."
                        previewText="Selected files"
                        filesLimit={100}
                        maxFileSize={50000000}
                        style={{
                            padding: "10px",
                            minHeight: "200px",
                            minWidth: "200px",
                        }}
                    />
                );
            case "Select Template":
                return (
                    <div>
                        <TextField
                            margin="dense"
                            id="template"
                            label="Instructions"
                            width="400px"
                            type="text"
                            onChange={(event) => {
                                setTemplate(event.target.value);
                            }}
                            value={template}
                            fullWidth
                            multiline
                            rows={5}
                            required
                        />
                    </div>
                );
            case "Update Outline":
                return (
                    <div data-color-mode="light">
                        <MarkdownEditorWithPreview
                            value={courseOutline}
                            onChange={handleCourseOutlineChange}
                            height={400}
                        />
                    </div>
                );
            case "Submit":
                return (
                    <div>
                        <Typography variant="h5">Summary</Typography>
                        <p style={{ marginTop: "20px" }}>
                            Uploaded Files: {uploadedFiles.map(file => file.name).join(", ")}
                        </p>
                        <p>Course Outline:</p>
                        <div data-color-mode="light">
                            <MDEditor.Markdown source={courseOutline} />
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            {alert}

            {/* Course Creation Modal Integrated */}
            <Dialog open={modal} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <div style={{ fontSize: '30px' }}>Create New Course</div>
                </DialogTitle>
                <DialogContent>
                    {renderDialogContent()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="quSandBoxColor">Cancel</Button>
                    <Button
                        onClick={() => {
                            if (currentDialog === "Submit") {
                                // Handle submit logic here, like saving the course or performing an action.
                                handleCreateProject();
                            } else {
                                // Proceed to the next dialog stage.
                                setCurrentDialog(dialogStages[dialogStages.indexOf(currentDialog) + 1]);
                            }
                        }}
                        color="quSandBoxColor"
                    >
                        {currentDialog === "Submit" ? "Submit" : "Next"}
                    </Button>

                </DialogActions>
            </Dialog>

            <Switch>
                <Route exact path={path}>
                    <GridContainer>
                        <GridItem xs={12} sm={8} md={8} lg={10}>
                            <SearchBar
                                value={searchValue}
                                onChange={(newValue) => searchInputValue(newValue)}
                                onRequestSearch={(newValue) => searchInputValue(newValue)}
                            />
                            <br />
                        </GridItem>
                        <GridItem
                            xs={12}
                            sm={4}
                            md={4}
                            lg={2}
                        >
                            <Button color="info" onClick={createProject} fullWidth>
                                Create Course
                            </Button>
                        </GridItem>
                    </GridContainer>
                    {loading ? (
                        <Heading title={<CircularProgress />} textAlign="center" />
                    ) : (
                        <GridContainer>
                            {allProjects.map((project, index) => (
                                <GridItem key={index} xs={12} sm={6} md={6} lg={4}>
                                    <Link
                                        to={{
                                            pathname: path + "/courses/" + project.PK.split("#")[1],
                                        }}
                                    >
                                        <Card style={{ minHeight: "245px", maxHeight: "245px" }}>
                                            <CardHeader stats icon>
                                                <CardIcon color="quSandBox">
                                                    {project.projectName}
                                                </CardIcon>

                                                <h3 className={classes.cardTitle}>
                                                    <small>
                                                        <img
                                                            // src={images("./qusandbox_logo_v2.5.png")}
                                                            src={randomImage}
                                                            alt=""
                                                            className={classes.thumbnail}

                                                        />
                                                    </small>
                                                </h3>
                                            </CardHeader>
                                            <CardBody style={{ paddingTop: "0px", paddingBottom: "0px" }} />
                                            <CardFooter>
                                                <Tooltip
                                                    id="tooltip-top"
                                                    title={project.projectBrief}
                                                    placement="bottom"
                                                    classes={{ tooltip: dashboardClasses.tooltip }}
                                                >
                                                    <h5
                                                        style={{
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                            width: "100%",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        {project.projectBrief
                                                            .split(" ")
                                                            .slice(0, 10)
                                                            .join(" ") + (project.projectBrief.split(" ").length > 10 ? "..." : "")}
                                                    </h5>
                                                </Tooltip>
                                            </CardFooter>
                                            <CardFooter stats style={{ marginTop: "0px" }}>
                                                {PERMISSION.indexOf(project.projectPermission) >=
                                                    PERMISSION.indexOf("clone") && (
                                                        <FileCopyIcon
                                                            style={{ color: "#435966" }}
                                                            onClick={(e) => e.preventDefault(cloneAlert(project))}
                                                        />
                                                    )}
                                                {/* {PERMISSION.indexOf(project.projectPermission) >=
                                                    PERMISSION.indexOf("own") && (
                                                        <EditIcon
                                                            style={{ color: "#435966" }}
                                                            onClick={(e) => e.preventDefault(editCard(project))}
                                                        />
                                                    )} */}
                                                {PERMISSION.indexOf(project.projectPermission) >=
                                                    PERMISSION.indexOf("own") && (
                                                        <DeleteIcon
                                                            style={{ color: "#435966" }}
                                                            onClick={(e) => e.preventDefault(deleteAlert(project))}
                                                        />
                                                    )}
                                            </CardFooter>
                                        </Card>
                                    </Link>
                                </GridItem>
                            ))}
                        </GridContainer>
                    )}
                </Route>
            </Switch>
        </div >
    );
}
